export const DAM_IMAGE_PATH = '/is/image/punto/'
export const DAM_VIDEO_PATH = '/is/content/punto/'

export const DECIMAL_PLACES = 2

export const Cuts = {
	CUT_10: 10,
	CUT_16: 16,
	CUT_40: 40,
	CUT_70: 70,
	CUT_100: 100,
	CUT_280: 280,
	CUT_320: 320,
	CUT_368: 368,
	CUT_480: 480,
	CUT_600: 600,
	CUT_640: 640,
	CUT_721: 721,
	CUT_768: 768,
	CUT_800: 800,
	CUT_960: 960,
	CUT_1024: 1024,
	CUT_1256: 1256,
	CUT_1350: 1350,
	CUT_1656: 1656,
	CUT_1920: 1920,
	CUT_2048: 2048,
}
